$.fn.rangeslider = function(options) {
    this.each((i, elem) => {
        const obj = $(elem);
        const defaultValue = obj.attr("value");
        const sliderMax = parseFloat(obj.attr("max") || 100);
        const sliderMin = parseFloat(obj.attr("min") || 0);
        const sliderStep = parseFloat(obj.attr("step") || 1);
        const sliderStop = (sliderMax - sliderMin) / sliderStep;
        const stepPercentage = 100 / sliderStop;
        let dots = "";

        if (sliderStop <= 30) {
            for (let i = 1; i < sliderStop; i++) {
                dots += `<div class='range__dot' id='${i}' style='left:${stepPercentage * i}%;'></div>`;
            }
        }

        const slider = $("<span>", {
            class: `range`
        });

        let icon = '';
        let iconEl = obj.parent().find('.field__ico');
        if (iconEl && iconEl.length) {
            icon = $(iconEl[0].outerHTML);
            icon.addClass('range__icon');
            icon = icon[0].outerHTML;
        }
        iconEl.remove();

        obj.wrap(slider);
        obj.addClass('range__input');
        obj.after(`
            <span class='range__container'>
                <span class='range__bar'>
                    <span class='range__progress'></span>
                    ${dots}
                </span>
                <span class='range__thumb'>
                    <span class='range__btn'>
                        <span class='range__nb'>0</span>
                        ${icon}
                    </span>
                </span>
            </span>
        `);
        obj.on("input", () => updateRangeSlider(obj));
        obj.on("change", () => updateRangeSlider(obj));
        updateRangeSlider(obj);
    });
};

const updateRangeSlider = (passObj) => {
    const obj = $(passObj);
    const value = parseFloat(obj.val());
    const min = parseFloat(obj.attr("min") || 0);
    const max = parseFloat(obj.attr("max") || 100);
    const base = parseFloat(obj.attr("base") || 0);
    const range = parseFloat(max - min);
    const percentage = parseFloat((value - min) * 100 / range);
    const nextObj = obj.next();
    const btn = nextObj.find("span.range__thumb");
    let baseStart = ((base - min) / range) * 100
    let baseEnd = ((value - min) / range) * 100
    if (baseEnd < baseStart) {
        let tmp = baseStart
        baseStart = baseEnd
        baseEnd = tmp
    }

    if (btn.data('percentage') == percentage) {return true;}

    btn.removeClass('range__thumb--min').removeClass('range__thumb--mid').removeClass('range__thumb--max')

    if (value === min) {
        btn.addClass('range__thumb--min');
    } else if (value === max) {
        btn.addClass('range__thumb--max');
    } else {
        btn.addClass('range__thumb--mid');
    }

    btn.css("left", `${percentage}%`);
    btn.data('percentage', percentage);

    nextObj.find("span.range__bar > span").css('left', `${baseStart}%`).css("width", `${baseEnd - baseStart}%`);
    nextObj.find("span.range__btn > .range__nb").text(value);
};
